const targetStack = []

export function pushTarget (target) {
  targetStack.push(target)
}

export function popTarget () {
  targetStack.pop()
}

export function getTargetFlow (num = 1) {
  if (targetStack.length >= num) {
    return targetStack[targetStack.length - num]
  }
}
